var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"flex-shrink-0",attrs:{"src":_vm.img}}),_c('p',{staticClass:"i_body_l i_ml_4"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }